// extracted by mini-css-extract-plugin
export default {"containerSpinner":"Spinner_containerSpinner__41TcQ","spinner":"Spinner_spinner__Z6H3Z","spinn":"Spinner_spinn__P6zvX"};